import { router, useLocalSearchParams } from 'expo-router'
import { useTranslation } from 'react-i18next'
import { useToast } from '@ui/toasts/useToastManager'
import Button from '@ui/buttons/Button'
import TileBlur from '@ui/tiles/TileBlur'
import { useStaff } from 'hooks/useSession'
import useAnimatedPress from '@ui/animated/useAnimatedPress'
import { Pressable } from 'react-native'

export default function PrescriptionManual() {
  const { animation, onPressIn, onPressOut } = useAnimatedPress()
  const { t } = useTranslation(['vision', 'toasts'])
  const staff = useStaff()
  const toast = useToast()
  const text = 'vision:source.sections.manual'
  const { order } = useLocalSearchParams<{ order: string }>()

  const onPress = () =>
    staff
      ? router.navigate({
          pathname: '/vision/prescription/manual',
          params: { order },
        })
      : toast({
          title: t('toasts:staffRequired'),
          variant: 'info',
        })

  return (
    <Pressable
      onPress={onPress}
      onPressIn={onPressIn}
      onPressOut={onPressOut}
      className="flex-1"
    >
      <TileBlur
        variant="option"
        title={t(`${text}.title`)}
        desc={t(`${text}.desc`)}
        cta={
          <Button
            noninteractive
            animation={animation}
            onPress={onPress}
            size="sm"
            variant="outlined"
            label={t(`${text}.cta`)}
          />
        }
        glassProps={{
          animation,
          image: require('@/images/prescription-external.png'),
          imageWrapperStyle: {
            transform: [{ rotate: '30deg' }],
            transformOrigin: 'bottom right',
            width: '133%',
            height: '133%',
          },
          imageStyle: {
            transform: [{ translateX: -75 }, { translateY: 200 }],
          },
          blurStyle: {
            opacity: 0.5,
            transform: [
              { translateX: 110 },
              { translateY: 0 },
              { scale: 1.33 },
              { rotate: '30deg' },
            ],
          },
        }}
      />
    </Pressable>
  )
}
